export const PAGE_EVENT_CHANGED = "PAGE_EVENT_CHANGED";



// WEBPACK FOOTER //
// ./src/store/PageEvents/actionTypes.js